import { Dispatch, SetStateAction } from 'react';
import { ace_index } from '@axo/shared/data-access/types';
import { FilterSelect } from '../FilterSelect';
import { areObjectsDifferent } from '../../utils/compareObjects';
import { setPageNumber } from '../SearchResults';

interface Props {
  query: ace_index.FindInput;
  setQuery: Dispatch<SetStateAction<ace_index.FindInput>>;
  editable?: boolean;
}

export function LastCompletedStep({
  query,
  setQuery,
  editable = false,
}: Props) {
  const state = getState(query);
  const value =
    options.find((option) => !areObjectsDifferent(state, option.value)) ??
    options[0];

  return (
    <FilterSelect
      items={options}
      onSelect={(option) => setQuery(setState(option.value))}
      stringify={(option) => option.label}
      value={value}
      label="Last completed form step"
      description="Filter applications by how many steps of the form has been completed"
      disabled={!editable}
    />
  );
}

const options: { label: string; value: Value }[] = [
  { label: 'All', value: undefined },
  { label: '1', value: { From: 1, To: 2 } },
  { label: '2', value: { From: 2, To: 3 } },
  { label: '3', value: { From: 3, To: 4 } },
  { label: '4', value: { From: 4, To: 5 } },
  { label: '5', value: { From: 5, To: 6 } },
  { label: '6', value: { From: 6, To: 7 } },
  { label: '7', value: { From: 7, To: 8 } },
  { label: '8', value: { From: 8, To: 9 } },
  { label: '9', value: { From: 9, To: 10 } },
];

function setState(range: Value): SetStateAction<ace_index.FindInput> {
  return (query) => ({
    ...setPageNumber(1)(query),
    SummaryLastCompletedStep: range,
  });
}

function getState(query: ace_index.FindInput) {
  return query.SummaryLastCompletedStep;
}

type Value = ace_index.FindInput['SummaryLastCompletedStep'];
